const ShowCounter = ({ hours, minutes, seconds }) => (
  <div style={{ display: 'inline-block' }} className="monospace">
    {hours}
    :
    {minutes}
    :
    {seconds}
  </div>
);

export default ShowCounter;
